import React from "react";
import InnerHtml from "../inner-html";
import { Link, useLocation } from "react-router-dom";
import If from "../../../vendors/components/If";

interface Props {
  sessaoPresencial: any;
}

export default function SessaoPresencialVisualizar({
  sessaoPresencial,
}: Props) {
  const formatoSessaoDescricao: any = {
    P: "Presencial",
    V: "Virtual",
    PV: "Presencial | Virtual",
  };

  const tipoSessao = formatoSessaoDescricao[sessaoPresencial.tpFormatoSessao];

  return (
    <>
      <div className="portal-evento-wrapper">
        <div className="portal-evento-principal">
          <div>
            <label>
              <b>Sessão: </b> {sessaoPresencial.sessao} , {!!tipoSessao && tipoSessao}
            </label>
          </div>
          <div>
            <label>
              <b>Local: </b> {sessaoPresencial.local}
            </label>
          </div>
          <div>
            <label>
              <b>Horário: </b> {sessaoPresencial.horario}
            </label>
          </div>

          <div>
            {sessaoPresencial.formulario != "" && (
              <label>
                <b>Formulário: </b>{" "}
                {
                  <a
                    style={{ cursor: "pointer" }}
                    href={sessaoPresencial.formulario}
                    target="blank"
                  >
                    <If condition={sessaoPresencial.formulario != ""}>
                      Link Formulário
                    </If>
                  </a>
                }
              </label>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
